import axiosService from "@/modules/axios-service";

class EmailPdfSubmissionService {
  path = "/email-pdf-submission";

  async getSetting() {
    return await axiosService.get(this.path);
  }

  async enable() {
    return await axiosService.post(this.path);
  }
}

export default new EmailPdfSubmissionService();
